import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BrowserMultiFormatReader,
  BarcodeFormat,
  BrowserQRCodeReader,
} from "@zxing/browser";

const CameraScanner = ({ showScanner, onClose }) => {
  const navigate = useNavigate();

  const videoRef = useRef(null);
  const controlsRef = useRef(null);
  const scannedRef = useRef(false);

  const [cameraError, setCameraError] = useState("");

  useEffect(() => {
    if (!showScanner || !videoRef.current) {
      return;
    }

    let cancelled = false;
    scannedRef.current = false;

    const startScanner = async () => {
      try {
        setCameraError("");

        console.log("Secure context:", window.isSecureContext);
        console.log("Media devices:", navigator.mediaDevices);

        if (!window.isSecureContext) {
          setCameraError(
            "Camera requires HTTPS. Please open this application using a secure HTTPS URL.",
          );
          return;
        }

        if (!navigator.mediaDevices) {
          setCameraError("Camera API is not available in this browser.");
          return;
        }

        if (!navigator.mediaDevices.getUserMedia) {
          setCameraError("Camera access is not supported in this browser.");
          return;
        }

        // const codeReader = new BrowserMultiFormatReader();
        // codeReader.possibleFormats = [BarcodeFormat.CODE_128];
        //--- QR code reader ---
        const codeReader = new BrowserQRCodeReader();

        const controls = await codeReader.decodeFromConstraints(
          {
            audio: false,
            video: {
              facingMode: {
                ideal: "environment",
              },
            },
          },
          videoRef.current,
          (result, error, controls) => {
            if (cancelled || !result || scannedRef.current) {
              return;
            }

            scannedRef.current = true;

            const scannedValue = result.getText();

            console.log("QR scanned value:", scannedValue);

            //stop camera after successful scan
            controls.stop();
            controlsRef.current = null;

            // close scannner
            onClose?.();

            // navigate to job details
            navigate(`/managejobs/view/${encodeURIComponent(scannedValue)}`);
          },
        );

        //handle scanner closing while camera is starting
        if (cancelled || scannedRef.current) {
          controls.stop();
        } else {
          controlsRef.current = controls;
        }
      } catch (error) {
        console.error("Camera scanner error:", error);

        setCameraError(
          `${error?.name || "Camera Error"}: ${
            error?.message || "Unknown error"
          }`,
        );
      }
    };

    startScanner();

    return () => {
      cancelled = true;

      if (controlsRef.current) {
        controlsRef.current.stop();
        controlsRef.current = null;
      }
    };
  }, [showScanner, navigate, onClose]);

  const closeScanner = () => {
    if (controlsRef.current) {
      controlsRef.current.stop();
      controlsRef.current = null;
    }

    onClose?.();
  };

  if (!showScanner) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.75)",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          width: "90%",
          maxWidth: "500px",
        }}
      >
        <h3>Scan HaulWeigh QR Code</h3>

        <div
          style={{
            position: "relative",
            width: "100%",
            aspectRatio: "4 / 3",
            overflow: "hidden",
            borderRadius: "8px",
            background: "#000",
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />

          {/* Scan target */}
          <div
            style={{
              position: "absolute",
              width: "65%",
              aspectRatio: "1 / 1",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",

              border: "3px solid #e67e00",
              borderRadius: "12px",
              pointerEvents: "none",
              boxSizing: "border-box",
            }}
          />
        </div>

        <p
          style={{
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          Position the QR code inside the box
        </p>

        {cameraError && <p style={{ color: "red" }}>{cameraError}</p>}

        <button
          type="button"
          onClick={closeScanner}
          style={{
            width: "100%",
            marginTop: "10px",
            padding: "10px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CameraScanner;
